import { useStaticQuery, graphql } from 'gatsby'

export const useMeetOurTeamQuery = () => {
  const { wpPage } = useStaticQuery(graphql`
    query MeetOurTeamQuery {
      wpPage(title: { eq: "Home" }) {
        meetOurTeam {
          meetOurTeam {
            title
            subtitle
            teamMembers {
              image {
                sourceUrl
              }
              name
              description
            }
          }
        }
      }
    }
  `)
  return wpPage.meetOurTeam.meetOurTeam
}
